import { jsx } from 'react/jsx-runtime';
import { createInstance, OptimizelyDecideOption } from '@optimizely/optimizely-sdk';
import { useState, useRef, useEffect } from 'react';
import { useSiteContext } from '@zooplus/commons-lang';
import { getEnv } from '../../env/environment.js';
import { sendAdobeFeatureFlagData } from '../../services/adobeService.js';
import { useCartContext } from '../CartProvider/CartProvider.js';
import Popover from '../Popover/Popover.js';
import cartPopoverConfig from './cartPopoverConfig.js';

const PopoverWrapper = ({ stage, actionInfo, debugMode = false, }) => {
    const { site } = useSiteContext();
    const { sid, cart } = useCartContext();
    const [proceedToCheckoutFlag, setProceedToCheckoutFlag] = useState();
    const optimizelyClientRef = useRef(createInstance({
        sdkKey: getEnv(stage).OPTIMILELY_KEY,
    }));
    useEffect(() => {
        if (sid) {
            (async () => {
                try {
                    const result = await optimizelyClientRef.current?.onReady();
                    if (result?.success) {
                        const user = optimizelyClientRef.current?.createUserContext(sid, {
                            siteId: site.id,
                            realm: site.realm,
                        });
                        const useHideProceedToCheckoutButton = user?.decide('sc-4215_hide_chk_btn_atcp', [
                            OptimizelyDecideOption.INCLUDE_REASONS,
                        ])?.enabled;
                        if (useHideProceedToCheckoutButton) {
                            sendAdobeFeatureFlagData(useHideProceedToCheckoutButton);
                            setProceedToCheckoutFlag(useHideProceedToCheckoutButton);
                        }
                    }
                }
                catch (error) {
                    console.error(error);
                }
            })();
        }
    }, [sid, site.realm, site.id]);
    const minOrderValue = cartPopoverConfig.minimumOrderValue[site.id];
    return (jsx("div", { "data-zta": "add-to-cart-popover-app", children: jsx(Popover, { minOrderValue: minOrderValue, debugMode: debugMode, proceedToCheckoutFlag: proceedToCheckoutFlag, actionInfo: actionInfo, cart: cart, realm: site.realm }) }));
};

export { PopoverWrapper as default };
//# sourceMappingURL=PopoverWrapper.js.map
